import React from 'react';
import { injectIntl } from 'react-intl';
import ReactDOM from 'react-dom';
import FormControl from 'react-bootstrap/lib/FormControl';
import { defaultMessages } from '../../../../libs/i18n/default';

class FormDate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      date: this.props.val || this.props.date
    };
    this.setDate = this.setDate.bind(this);
    this.existingDate = this.existingDate.bind(this);
  }
  componentDidMount(){
    const monthEl = document.querySelector(`#${this.props.id || 'date'}_month`);
    const yearEl = document.querySelector(`#${this.props.id || 'date'}_year`);
    const dayEl = document.querySelector(`#${this.props.id || 'date'}_day`);

    if (monthEl) monthEl.value = this.existingDate('month');
    if (yearEl) yearEl.value = this.existingDate('year');
    if (dayEl) dayEl.value = this.existingDate('day');
  }
  existingDate(type){
    var v = '';
    if (this.state.date!='' && this.state.date!=undefined){
      var date = this.state.date.toString().split("-");
      switch(type) {
        case 'month':
          v = date[1];
          break;
        case 'day':
          v = date[2];
          break;
        case 'year':
          v = date[0];
          break;
      }
    }
    return v;
  }
  months(){
    const { formatMessage } = this.props.intl;
    var months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    const mo = [<option key="disabled_month"></option>];
    months.map((month, index) => {
      var index_val = ("0" + (index+1)).slice(-2);
      var month_id = "clientComponentsDateFormMonths" + month;
      var month_val = formatMessage(defaultMessages[month_id]);
      mo.push(<option key={index_val} value={index_val}>{month_val}</option>);
    });
    return mo;
  }
  setDate() {
    const month = ReactDOM.findDOMNode(this.refs[`${this.props.id || 'date'}_month`]).value;
    const day = ReactDOM.findDOMNode(this.refs[`${this.props.id || 'date'}_day`]).value;
    const year = ReactDOM.findDOMNode(this.refs[`${this.props.id || 'date'}_year`]).value;
    if (this.validYear(year) && this.validDay(day) && month!=''){
      var date = new Date(year, parseInt(month-1), day);
      if (date != 'Invalid Date'){
        let y = date.getFullYear()
        let m = String(date.getMonth() + 1).padStart(2, '0')
        let d = String(date.getDate()).padStart(2, '0')
        date = `${y}-${m}-${d}`;
        this.setState({date: date});
      }else{
        date = null;
      }
    }else{
      date = null;
    }
    if (this.props.updateDateState){
      this.props.updateDateState(date);
    }
  }
  validDay(d){
    var regexp = new RegExp(/^\d?\d{1}$/);
    return(regexp.test(d));
  }
  validYear(y){
    var regexp = new RegExp(/^(?:19|20)\d{2}$/);
    return(regexp.test(y));
  }
  render() {
    const { formatMessage } = this.props.intl;
    return (
      <div>
        <FormControl
          type="number"
          placeholder={formatMessage(defaultMessages.clientComponentsDateFormDateDay)}
          ref={`${this.props.id || 'date'}_day`}
          id={`${this.props.id || 'date'}_day`}
          maxLength={2}
          onInput={this.setDate}
          onChange={this.setDate}
          onBlur={this.setDate}
          style={{display: 'inline', width: '60px', marginRight: '10px'}} />
        <FormControl
          componentClass="select"
          placeholder="select"
          ref={`${this.props.id || 'date'}_month`}
          id={`${this.props.id || 'date'}_month`}
          onChange={this.setDate}
          onBlur={this.setDate}
          style={{display: 'inline', width: '100px', marginRight: '10px', padding: '3px'}} >
            {this.months()}
        </FormControl>
        <FormControl
          type="number"
          placeholder={formatMessage(defaultMessages.clientComponentsDateFormDateYear)}
          ref={`${this.props.id || 'date'}_year`}
          id={`${this.props.id || 'date'}_year`}
          onInput={this.setDate}
          onChange={this.setDate}
          onBlur={this.setDate}
          maxLength={4}
          style={{display: 'inline', width: '100px'}} />
      </div>
    );
  }
}

export default injectIntl(FormDate);
